












































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import {Actions, Endpoints, Mutations} from '@/ts/store/Constants';
import InlineImages from '@/components/Gallery/InlineImages.vue';
import moment from 'moment';
import UserInquiryType from '@/ts/UserInquiryType';
import UserInquiryCategory from '@/ts/UserInquiryCategory';
import UserInquiry from '@/ts/UserInquiry';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import DeviceMethods from '@/mixins/DeviceMethods.vue';

import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Keyboard } from '@capacitor/keyboard';

@Component({
    components: {
        InlineImages,
    },
})
export default class AddNewTicketForm extends Mixins(
    DeviceMethods,
    LocalizationMethods,
    InputFieldMethods,
) {
    @Prop() public withTypeSelect: boolean = null;
    @Prop() public withCategorySelect: boolean = null;

    public form: any = {
        type: this.withTypeSelect ? '' : this.activeType.id,
        category: this.withCategorySelect ? '' : this.activeCategory.id,
        title: '',
        description: '',
    };
    public ticketSaving: boolean = false;
    public savedTicket: any = null;
    public attachedFiles: any[] = [];
    public deviceInfo: any = null;
    private fileData: File;

    constructor() {
        super();
        this.initializeKeyboardListener();
    }

    get activeType(): UserInquiryType {
        return this.$store.getters['HomeAssistant/getActiveType'];
    }

    get activeCategory(): UserInquiryCategory {
        return this.$store.getters['HomeAssistant/getActiveCategory'];
    }

    get activeInquiry(): UserInquiry {
        return this.$store.getters['HomeAssistant/getActiveInquiry'];
    }

    get types(): UserInquiryType[] {
        return this.$store.getters['UserTicketsAttributes/getInquiryTypes'];
    }

    get categories(): UserInquiryCategory[] {
        return this.withTypeSelect
            ? this.$store.getters['UserTicketsAttributes/getTypeInquiryCategories'](this.form.type)
            : this.$store.getters['UserTicketsAttributes/getInquiryCategories'];
    }

    get fileIsUploading() {
        return this.$store.getters['FileUpload/getFileIsUploading'];
    }

    public initializeKeyboardListener(): void {
        if (this.$store.state.Viewport.deviceInfo.platform === 'web') {
            return;
        }

        Keyboard.setAccessoryBarVisible({ isVisible: true });
    }

    public showFileInputDialog(): void {
        (this.$refs.fileInputElement as HTMLInputElement).click();
    }

    public showCameraDialog(): void {
        this.device().then((deviceInfo: any) => {
            deviceInfo.platform === 'web' ? this.showFileInputDialog() : this.requestMobileImage();
        });
    }

    public removeAttachItem(index: number) {
        this.attachedFiles = this.attachedFiles.filter((file: any, i: number) => i !== index);
        this.resetAttachmentInput();
    }

    public resetAttachmentInput() {
        this.fileData = null;

        const input = this.$refs.fileInputElement as HTMLInputElement;
        input.type = 'text';
        input.type = 'file';
    }

    public finalizeTicketCreation() {
        this.$store.commit(Mutations.SET_ADD_NEW_TICKET_ANSWER_VISIBILITY, false);
        this.$store.commit(Mutations.SET_ADD_NEW_TICKET_THANKS_VISIBILITY, true);
        this.$store.commit(Mutations.SET_ADD_NEW_TICKET_THANKS_MODE, 'NewTicket');
    }

    public cancel() {
        this.$store.commit(Mutations.SET_ADD_NEW_TICKET_ANSWER_VISIBILITY, false);
    }

    public addNewTicket() {
        this.$validator.validate().then((valid: boolean) => {
            if (valid) {
                this.ticketSaving = true;

                const formData: any = new FormData();

                formData.append('inquiry_id', !this.withCategorySelect ? this.activeInquiry.id : null);
                formData.append('category_id', this.form.category);
                formData.append('title', this.form.title);
                formData.append('question', this.form.description);

                this.$store.dispatch(Actions.USER_ADD_NEW_TICKET, {
                    requestData: formData,
                    vue: this,
                    callback: (savedTicket: any) => {
                        if (savedTicket === null) {
                            this.ticketSaving = false;
                            return;
                        }

                        this.savedTicket = savedTicket;

                        (async () => {
                            for (let fileIndex = 0; fileIndex < this.attachedFiles.length; fileIndex++) {
                                const imagesFormData = new FormData();
                                imagesFormData.append('image', this.attachedFiles[fileIndex]);

                                await this.$store.dispatch(Actions.UPLOAD_FILE, {
                                    method: 'PUT',
                                    endpoint: Endpoints.Tickets.TICKET_IMAGES(this.savedTicket.id),
                                    file: imagesFormData,
                                    fileIndex,
                                });
                            }

                            this.finalizeTicketCreation();
                            this.ticketSaving = false;
                        })();
                    },
                });
            }
        });
    }

    public uploadImage(tempImage: any, canvas: any, context: any) {
        const width = 1024;
        const widthProportion = width / tempImage.width;
        const height = tempImage.height * widthProportion;

        canvas.width = width;
        canvas.height = height;
        context.drawImage(tempImage, 0, 0, width, height);
        tempImage = null;

        canvas.toBlob((blob: any) => {
            const file = new File([blob], moment().format('x') + '.jpeg', { type: 'image/jpeg' });
            this.attachedFiles.push(file);
        });
    }

    public handleFileChange(event: Event) {
        this.fileData = (event.target as HTMLInputElement).files[0];

        if (typeof this.fileData === 'undefined' || this.fileData === null) {
            this.resetAttachmentInput();
            return;
        }

        const reader = new FileReader();
        const tempImage = new Image();
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        reader.readAsDataURL(this.fileData);
        reader.onload = (e: any) => {
            const image  = new Image();
            image.src = e.target.result;

            image.onload = () => {
                const height = image.height;
                const width  = image.width;
                tempImage.src = e.target.result;
            };

            tempImage.onload = () => this.uploadImage(tempImage, canvas, context);
        };
    }

    private async requestMobileImage(): Promise<boolean> {
        const image = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.DataUrl,
            source: CameraSource.Prompt,
        })
            .then((photo) => {
                let tempImage = new Image();
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');

                tempImage.onload = () => {
                    const width = 1024;
                    const widthProportion = width / tempImage.width;
                    const height = tempImage.height * widthProportion;

                    canvas.width = width;
                    canvas.height = height;
                    context.drawImage(tempImage, 0, 0, width, height);
                    tempImage = null;
                    canvas.toBlob((blob) => {
                        const file = new File([blob], moment().format('x') + '.jpeg', { type: 'image/jpeg' });
                        this.attachedFiles.push(file);
                    });

                };

                tempImage.src = photo.dataUrl;
            });

        return true;
    }
}
